export default __webpack_public_path__ + "static/media/bkwp-logotype-d.2c731ac9.svg";